export default __webpack_public_path__ + "static/4i-53545bf0c95fb5bef17517d4ac17f983.woff2";